import { saveAs } from 'file-saver';

import type {
  DocumentDetailsResponse,
  ReconciliationDocumentType,
  ReconciliationImportResponse,
  ReconciliationLog,
} from '@/api/domains/reconciliation.types';
import { httpClient } from '@/shared/lib/axios';

const EXTENDED_TIMEOUT = 5 * 60 * 1000;

export const ReconciliationApi = {
  importFile: async (
    orderGuid: string,
    documentType: ReconciliationDocumentType,
    file: File,
  ): Promise<ReconciliationImportResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await httpClient.post<ReconciliationImportResponse>(
      `orders/${orderGuid}/import/${documentType}`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: EXTENDED_TIMEOUT,
      },
    );

    return data;
  },

  fetchDocumentDetails: async (orderGuid: string) => {
    const { data } = await httpClient.get<DocumentDetailsResponse>(`orders/${orderGuid}/document/details`);

    return data;
  },

  downloadAct: async (orderGuid: string) => {
    const response = await httpClient.get<Blob>(`reconciliation/${orderGuid}/act`, {
      responseType: 'blob',
    });

    const { data, headers } = response;
    const contentDisposition: string | undefined = headers['content-disposition'];

    let filename = 'reconciliation-act.xlsx';

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*=utf-8''(.*)$/);

      if (match) {
        try {
          filename = decodeURIComponent(match[1]);
        } catch {
          filename = match[1];
        }
      }
    }

    saveAs(data, filename);
  },

  fetchLog: async (orderGuid: string) => {
    const { data } = await httpClient.get<ReconciliationLog>(`orders/${orderGuid}/document/logs`);

    return data;
  },
};
